import { styled } from '@mui/material/styles';

type TIFrame = {
    $isFullScreen: boolean;
};
export const Iframe = styled('iframe')<TIFrame>((props) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: props.$isFullScreen ? '100%' : '1px',
    height: props.$isFullScreen ? '100%' : '1px',
    borderWidth: 0,
}));
